// // Use $ instead of jQuery without replacing global $
(function ($) {
    $(document).ready(function () {
        var url = window.location.pathname;
        if((url === "/company/leadership/") && ($('html').hasClass('ua-mobile')===true)){
            $("body .banner-second-level .bg-img img").css({'object-fit':"contain"});
        }
    });
})(jQuery);